import React, { useEffect, useState } from "react";
import { getPeriods } from "../../assets/js/api";
import { getCurrentLanguage, translate } from "../../assets/js/functions";
import { Link } from "react-router-dom";
import SectionDark from "../../components/Partials/SectionDark";
import SectionWhite from "../../components/Partials/SectionWhite";
import DeafaultLayout from "../../components/Layout/DefaultLayout";
import logoExpo from "../../assets/img/logo-expo.svg";
import logoExpoEus from "../../assets/img/logo-expo-euskera.svg";
import $ from "jquery";
import "../../assets/jquery-pagepiling/jquery.pagepiling";
import Menu from "../../components/Partials/Menu";
import ExpoFooter from "../../components/Partials/ExpoFooter";
import Langs from "../../components/Partials/Langs";
import { useLocation } from "react-router-dom";

export default function Exposition() {
  const [periods, setPeriods] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  let location = useLocation();
  const [logo, setLogo] = useState(null);

  useEffect(() => {
    if (location.hash) {
      hashUpdated(location.hash.replace("#", ""));
    }
  }, [location]);

  useEffect(() => {
    getPeriods().then((periods) => {
      setPeriods(periods);
    });
  }, []);

  useEffect(() => {
    const lang = getCurrentLanguage();
    if (lang == "es") {
      setLogo(logoExpo);
    } else if (lang == "eu") {
      setLogo(logoExpoEus);
    }
  }, []);

  const initializePagePiling = (periods) => {
    if (screenWidth >= 1024) {
      let ids = [];
      let names = [];
      if (periods) {
        periods.forEach((value) => {
          ids = [...ids, value.term_id];
          names = [...names, value.start + "-" + value.end];
          value.childrens.forEach((value) => {
            ids = [...ids, value.term_id];
            names = [...names, value.term];
          });
        });

        $("#pagepiling").pagepiling({
          direction: "horizontal",
          anchors: ids,
          navigation: {
            textColor: "#fff",
            bulletsColor: "#fff",
            position: "",
            tooltips: names,
          },
        });

        setIsInitialized(true);
      }

      if (location.hash) {
        hashUpdated(location.hash.replace("#", ""));
      }
    } else {
      setIsInitialized(false);
    }
  };

  // useEffect(() => {
  //   const handleResize = () => {
  //     setScreenWidth(window.innerWidth);
  //   };

  //   window.addEventListener("resize", handleResize);

  //   return () => {
  //     window.removeEventListener("resize", handleResize);
  //   };
  // }, []);

  useEffect(() => {
    setTimeout(() => {
      initializePagePiling(periods);
    }, 30);
  }, [screenWidth, periods]);

  const nextSlide = () => {
    if (typeof $.fn.pagepiling.moveSectionDown !== "undefined") {
      $.fn.pagepiling.moveSectionDown();
    }
  };

  const prevSlide = () => {
    if (typeof $.fn.pagepiling.moveSectionUp !== "undefined") {
      $.fn.pagepiling.moveSectionUp();
    }
  };

  const hashUpdated = (hash) => {
    if (typeof $.fn.pagepiling.moveTo !== "undefined") {
      $.fn.pagepiling.moveTo(hash);
    }
  };

  if (!periods) {
    return <div>Loading...</div>;
  }

  return (
    <DeafaultLayout pageMeta={{}}>
      <header>
        <a href="#main-nav" className="skip-link">
          Menú principal
        </a>
        <a href="#main" className="skip-link">
          Contenido principal
        </a>
        <div className="is-flex is-align-items-center gap-7 py-5 px-6">
          {periods ? <Menu periods={periods} /> : ""}
          <h1
            aria-label={translate("Símbolos de un tiempo")}
            className="site-title"
          >
            <Link to={"/"}>
              <img
                src={logo}
                alt=""
                width="169"
                height="60"
                className="is-hidden-mobile"
              />

              <img
                src={logo}
                alt=""
                width="169"
                height="60"
                className="is-hidden-tablet"
              />
            </Link>
          </h1>

          <Langs></Langs>
        </div>
      </header>
      <main className="main-content h-100" id="main">
        {periods ? (
          <React.Fragment>
            <div id="pagepiling" className="is-hidden-mobile">
              {periods.map((period) => {
                return (
                  <>
                    <SectionDark
                      key={"period_" + period.section_id}
                      period={period}
                      section={true}
                    ></SectionDark>
                    {period.childrens.map((year) => {
                      return (
                        <SectionWhite
                          key={"year_" + year.section_id}
                          year={year}
                          section={true}
                        ></SectionWhite>
                      );
                    })}
                  </>
                );
              })}
            </div>

            <div className="is-hidden-tablet">
              {periods.map((period) => {
                return (
                  <>
                    <SectionDark
                      key={"period_" + period.section_id}
                      period={period}
                      section={false}
                      id={period.term_id}
                    ></SectionDark>
                    {period.childrens.map((year) => {
                      return (
                        <SectionWhite
                          key={"year_" + year.section_id}
                          year={year}
                          section={false}
                          id={year.term_id}
                        ></SectionWhite>
                      );
                    })}
                  </>
                );
              })}
            </div>
          </React.Fragment>
        ) : (
          <div className="loader1">
            <div></div>
          </div>
        )}
      </main>
      <ExpoFooter next={nextSlide} prev={prevSlide}></ExpoFooter>
    </DeafaultLayout>
  );
}
